var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtzCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 178",
    d: "M100.5 50C100.5 77.6142 78.1142 100 50.5 100C22.8858 100 0.5 77.6142 0.5 50C0.5 22.3858 22.8858 0 50.5 0C78.1142 0 100.5 22.3858 100.5 50ZM29.1743 50C29.1743 61.7779 38.7221 71.3257 50.5 71.3257C62.2779 71.3257 71.8257 61.7779 71.8257 50C71.8257 38.2221 62.2779 28.6743 50.5 28.6743C38.7221 28.6743 29.1743 38.2221 29.1743 50Z",
    fill: "#343947"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtzCircles);
export default __webpack_public_path__ + "static/media/ptz-circles.1077f152efbc80843dcccfba26c2c363.svg";
export { ForwardRef as ReactComponent };